// Context for mobile menu state - used to communicate between Layout and PageHeader
import React, { createContext, useContext, ReactNode } from 'react';

interface MobileMenuContextType {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
  unreadCount: number;
}

const MobileMenuContext = createContext<MobileMenuContextType | undefined>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const useMobileMenu = () => {
  const context = useContext(MobileMenuContext);
  if (!context) {
    // Return default values if not within provider (e.g., during SSR or standalone usage)
    return {
      isOpen: false,
      toggle: () => {},
      open: () => {},
      close: () => {},
      unreadCount: 0
    };
  }
  return context;
};

interface MobileMenuProviderProps {
  children: ReactNode;
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
  unreadCount: number;
}

export const MobileMenuProvider: React.FC<MobileMenuProviderProps> = ({
  children,
  isOpen,
  toggle,
  open,
  close,
  unreadCount
}) => {
  return (
    <MobileMenuContext.Provider value={{ isOpen, toggle, open, close, unreadCount }}>
      {children}
    </MobileMenuContext.Provider>
  );
};
